/**
 * Maps resource types to their corresponding icon names from remixIcons
 */
export type ResourceType =
  | 'guide'
  | 'template'
  | 'whitepaper'
  | 'checklist'
  | 'presentation'
  | 'spreadsheet'
  | 'document'
  | 'other'

const RESOURCE_ICON_MAP: Record<ResourceType, string> = {
  guide: 'guide-line',
  template: 'layout-4-line',
  whitepaper: 'file-paper-line',
  checklist: 'check-line',
  presentation: 'file-ppt-2',
  spreadsheet: 'file-excel-2-line',
  document: 'file-text-line',
  other: 'file-line',
}

const DEFAULT_ICON = 'file-line'

/**
 * Gets the icon name for a given resource type
 * @param resourceType - The resource type
 * @returns The icon name to use, or the default icon if not found
 */
export const getResourceIcon = (resourceType?: ResourceType | string | null): string => {
  if (!resourceType) {
    return DEFAULT_ICON
  }

  const normalizedType = resourceType.toLowerCase() as ResourceType
  return RESOURCE_ICON_MAP[normalizedType] || DEFAULT_ICON
}

